
<template>
  <div
    class="tw-grid tw-grid-cols-12 tw-rounded-lg tw-border tw-items-center"
  >
    <slot />
  </div>
</template>
